import React from 'react';
import './CV.css';

const CV = () => {
  return (
    <div className="cv-container">
      <div className="cv-content">


        <h2>Education</h2>
        <p><strong>Harvard University</strong>, Cambridge, MA — AB-AM in Mathematics, AB in Classics (September 2024 – May 2028, expected)</p>
        <ul>
          <li>4.000/4.000 GPA</li>
          <li><strong>Coursework:</strong>
            <ul className="coursework-grid">
              <li>Math 55a – Studies in Algebra and Group Theory</li>
              <li>Math 114 – Analysis of Function Spaces, Measure, and Integration</li>
              <li>Math 213a – Advanced Complex Analysis (Graduate)</li>
              <li>Math 213br – Riemann Surfaces (Graduate)</li>
              <li>Math 212 – Real Analysis (Graduate)</li>
              <li>Math 222 – Lie Groups and Lie Algebras (Graduate)</li>
              <li>Math 129 – Number Fields (Audit)</li>
              <li>MIT 18.725 – Algebraic Geometry I (Graduate)</li>
              <li>Math 231a – Algebraic Topology I (Graduate)</li> 
              <li>Math 232br – Algebraic Geometry II (Graduate)</li>
              <li>Math 231br – Algebraic Topology II (Graduate)</li>
              <li>Math 259A - Mapping Class Groups and 4-Manifolds (Graduate)</li>
              <li>Directed Readings in p-adic analysis</li>
              <li>Greek 112a – Texts and Contexts</li>
              <li>Greek 112b – Texts and Contexts</li>
              <li>Latin 112a – Texts and Contexts</li>
              <li>Latin 112b – Texts and Contexts</li>
              <li>Latin 134 – Archaic Latin</li>
              <li>Ling 225 – Hittite</li>
              <li>Greek 107 - Thucydides and Experimental History</li>
              <li>Classical Philology 249 - Mycenaean Greek</li>
              <li>Expos 20 – Problems of Meaning in Language, Literature, and Life</li>
            </ul>
          </li>
        </ul>

        <h2>Experience</h2>
        
        <p><strong>Math 213a/br Course Assistant</strong>, Harvard Mathematics - Cambridge, MA (September 2025 –)</p>
        <ul>
          <li>Grade assignments and host office hours and review sessions for graduate complex analysis (213a) and Riemann surfaces (213br) taught by Dr. Curtis McMullen.</li>
        </ul>

        <p><strong>Yale SUMRY REU Researcher</strong>, Yale Mathematics - New Haven, CT (June 2025 – August 2025)</p>
        <ul>
          <li>Researching quantum chaos and damped wave equations under Dr. Ruoyu Wang, Dr. Tristan Leger, and Yutong Wu of Yale University.</li>
          <li>Currently preparing a preprint on damped wave equations on triangular domains.</li>
        </ul>

        <p><strong>Field Archaeologist</strong>, Lyttos Archaeological Project – Lyttos, Crete (July–August 2024, May–June 2025)</p>
        <ul>
          <li>Worked under Dr. Angelos Chaniotis of the Institute for Advanced Study and Dr. Georgios Tsolakis on the excavation of Sector B of the Hellenistic and Roman site of Lyktos.</li>
        </ul>

        <p><strong>Freelance Software Development</strong> (Summer 2021, 2022)</p>
        <ul>
          <li>Did paid freelance software development work. Highlights include writing Shopify integrations for KBDfans, one of the largest online mechanical keyboard parts retailers.</li>
        </ul>

        <p><strong>Software Development Intern</strong>, Fabric Health (formerly Florence Labs) - New York, NY (Summer 2021, 2022)</p>
        <ul>
          <li>Wrote unit tests and automated infrastructure for Twilio-based communication features using Pulumi; integrated Twilio services into AWS cloud architecture ensuring HIPAA compliance.</li>
        </ul>
         <h2> Awards </h2>
         <p><strong>Detur Book Prize</strong>, Harvard University (January 2026)</p>
         <ul>
          <li>The Detur Book Prize recognizes sophomores who attained very high academic standing in their first three semesters at the College.</li>
         </ul> 
         <p><strong>Wendell Scholar</strong>, Harvard University (December 2025)</p>
         <ul>
          <li>The Jacob Wendell Scholarship Prize, which was established in 1899 by bequest of Jacob Wendell, is awarded to a Harvard College sophomore identified by the selection committee as the most promising and broad-ranging scholar in the student's class, without reference to financial need. This prize of $21,000 is awarded on the basis of a student’s first-year academic record, writing sample, short essay, and letter of recommendation.</li>
         </ul>
         <p><strong>John Harvard Scholar</strong>, Harvard University (November 2025)</p>
         <ul>
          <li>Given to top 5% of the class.</li>
         </ul>
        {/* <div className="cv-download">
          <a href="/JSB_CV_2025.pdf" download>Download Full CV (PDF)</a>
        </div> */}
      </div>
    </div>
  );
};

export default CV;

